module.exports = __webpack_public_path__ + "img/bg.4a478d55.jpg";